import { createResourceCollection } from '@/request'
import { ThermostatCostCategoryControls } from '@/types/thermostatCostCategoryControls'

export const thermostatCostCategoryControlsCollection =
  createResourceCollection<ThermostatCostCategoryControls>({
    name: 'thermostatCostCategoryControls',
    selector: (state) => state.thermostatCostCategoryControls,
    apiConfig: {
      path: 'thermostats',
    },
  })

export default thermostatCostCategoryControlsCollection.slice.reducer
